
import type { RouteLocationNormalizedGeneric } from '#vue-router'

export const getNotifyTypeFromUrl = (routeFromParams?: RouteLocationNormalizedGeneric): string | null => {
  const routeFromHook = useRoute()

  const route = routeFromParams || routeFromHook

  if (route) {
    return (route.query?.notify_type || null) as string | null
  } else {
    return null
  }
}
